import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const apiService = axios.create({
  baseURL: API_BASE_URL,
});

export const signup = async (userData) => {
    try {
      userData.phone_no = parseInt(userData.phone_no);
      const response = await apiService.post("/register", userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  export const reSendOtp = async (payload) => {
    try {
      const reSendOtpData = {
        email: payload,
      };
      const response = await apiService.post("/resend-otp", reSendOtpData);
      return response.data;
    } catch (error) {}
  };
  export const login = async (userData) => {
    try {
      const response = await apiService.post("/login", userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  export const registerApi = async (registerData) => {
    try {
      const response = await apiService.post("/register", registerData);
      return response.data;
    } catch (error) {
      throw error;
    }
  };
 
  export const verfiyOtp = async (payload) => {
    try {
      const response = await apiService.post("/check-otp", payload);
      return response.data;
    } catch (error) {}
  };
  export const forgetPassword = async (email) => {
    try {
      const response = await apiService.post("/forget-password", email);
      return response.data;
    } catch (error) { 
      throw error
    }
  };